<template>
  <div class="middle">
      <p>加载中...</p>
  </div>
</template>
<script>
  import  $  from 'jquery';

  export default {
    name: "middle",
    data(){
      return {

      }
    },
    methods:{
      wxlogin(){
        var that = this
        $.ajax({
          url: '/api/proxy/getToken',
          dataType: 'json',
          type: 'get',
          success:(res)=>{
            if(res.status===1){
              that.$toast("登录成功！");
              that.$store.commit("setLogin",1);
              that.tools.setStorage('mooc_user_token',res.data.user_token,res.data.expire_time);
              that.tools.setStorage('mooc_user_id',res.data.mooc_user_id,res.data.expire_time);
              that.tools.setStorage('mooc_user_salt',res.data.salt,res.data.expire_time);
              that.tools.setStorage('center_id',res.data.center_id,res.data.expire_time);
              that.tools.setStorage('user_type',res.data.user_type,res.data.expire_time);
              that.tools.setStorage('center_key',res.data.center_key,res.data.expire_time);
                that.$api.get('',{
                  api:"/v1/my/index",
                  'user_type':that.tools.getStorage("user_type"),
                },res=>{
                  if(res.status == 1){
                    that.$store.commit("setMyid",res.data.id);
                    that.$store.commit("setMygroupIds",res.data.groupIds);
                    that.$router.push("/index")
                  }else{
                    that.$store.commit("setMyid",0);
                    that.$store.commit("setMygroupIds",[]);
                  }
                })
            }else{
              that.$toast(res.msg);
            }
          }
        })
      },
    },
    mounted(){
      this.wxlogin();
    }
  }
</script>

<style scoped>
  .middle{
    font-size: .373rem;
    text-align: center;
    color: #999;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/login/middle.vue